import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function TestimonialSlider() {
    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      };
  return (
    <div>
    <section className="testimonials mask-image" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/mask/mask_5.png)' }}>
        <div className="section section-bg-fix" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/bg/bg_3.png)' }}>
            <div className="container">
                <Slider {...settings}className="testimonial_slider">
                    <div className="slide-item">
                        <div className="testimonial_item">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                            <div className="testimonial_author text-center">
                                <img src="/tm/react/fit2fine/assets/images/testimonial/1.jpg" alt="img" className="image-fit"/>
                                <h5 className="author_name mb-0">Batista</h5>
                                <p className="author_post">Manager</p>
                            </div>
                        </div>
                    </div>
                 
                    <div className="slide-item">
                        <div className="testimonial_item">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                            <div className="testimonial_author text-center">
                                <img src="/tm/react/fit2fine/assets/images/testimonial/2.jpg" alt="img" className="image-fit"/>
                                <h5 className="author_name mb-0">The Undertaker</h5>
                                <p className="author_post">Manager</p>
                            </div>
                        </div>
                    </div>
                   
                    <div className="slide-item">
                        <div className="testimonial_item">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco </p>
                            <div className="testimonial_author text-center">
                                <img src="/tm/react/fit2fine/assets/images/testimonial/3.jpg" alt="img" className="image-fit"/>
                                <h5 className="author_name mb-0">The Great Khali</h5>
                                <p className="author_post">Manager</p>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </div>
    </section>
    </div>
  )
}

export default TestimonialSlider